/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum PiiType {
  None = 'None',
  SearchableName = 'SearchableName',
  NameSearchRequest = 'NameSearchRequest',
  FileNameRequest = 'FileNameRequest',
  UrlRequest = 'UrlRequest',
  QueryRequest = 'QueryRequest',
  OpportunityQueryRequest = 'OpportunityQueryRequest',
  SearchableGlobal = 'SearchableGlobal',
  SearchableGlobalNoRegex = 'SearchableGlobalNoRegex',
  SearchableGlobalFile = 'SearchableGlobalFile',
  SearchableGlobalFileNoRegex = 'SearchableGlobalFileNoRegex',
  NonSearchableClient = 'NonSearchableClient',
  SearchableClient = 'SearchableClient',
  NonSearchableContactInformation = 'NonSearchableContactInformation',
  SearchableContactInformation = 'SearchableContactInformation',
  NonSearchableMisc = 'NonSearchableMisc',
  SearchableMisc = 'SearchableMisc',
  NonSearchableOperational = 'NonSearchableOperational',
  SearchableOperational = 'SearchableOperational',
  NonSearchableOrganisation = 'NonSearchableOrganisation',
  SearchableOrganisation = 'SearchableOrganisation',
  NonSearchableParty = 'NonSearchableParty',
  SearchableParty = 'SearchableParty',
  NonSearchablePerson = 'NonSearchablePerson',
  SearchablePerson = 'SearchablePerson',
  NonSearchableDate = 'NonSearchableDate',
  NonSearchableE164 = 'NonSearchableE164',
  NonSearchableDocument = 'NonSearchableDocument',
  NonSearchableEmail = 'NonSearchableEmail',
  NonSearchableIban = 'NonSearchableIban',
  NonSearchableLei = 'NonSearchableLei',
  LookupUrlRequest = 'LookupUrlRequest',
  LookupRequest = 'LookupRequest'
}
